// Shared formatters. Both admin pages grew their own near-identical copies of
// these; there is one set now. Dates render in the viewer's locale, which for
// this app is Australian, so day-first.

export function formatDate(input: number | null): string {
  if (!input) return "—";
  return new Date(input).toLocaleString();
}

export function formatRelative(input: number | null): string {
  if (!input) return "—";
  const delta = Math.max(0, Date.now() - input);
  const minutes = Math.round(delta / 60_000);
  if (minutes < 1) return "now";
  if (minutes < 60) return `${minutes}m ago`;
  const hours = Math.round(minutes / 60);
  if (hours < 24) return `${hours}h ago`;
  return `${Math.round(hours / 24)}d ago`;
}

export function formatIsoDate(input: string | null): string {
  if (!input) return "—";
  const date = new Date(input);
  return Number.isNaN(date.getTime()) ? "—" : date.toLocaleString();
}

export function formatIsoRelative(input: string | null): string {
  if (!input) return "—";
  const timestamp = new Date(input).getTime();
  return Number.isNaN(timestamp) ? "—" : formatRelative(timestamp);
}

export function formatBytes(input: number | null): string {
  if (input === null || !Number.isFinite(input)) return "—";
  if (input < 1024 * 1024) return `${Math.round(input / 1024)} KiB`;
  if (input < 1024 * 1024 * 1024) return `${(input / (1024 * 1024)).toFixed(1)} MiB`;
  return `${(input / (1024 * 1024 * 1024)).toFixed(1)} GiB`;
}

export function formatQuota(current: number | null, total: number | null, unit = ""): string {
  if (current === null && total === null) return "—";
  const currentText = current === null ? "—" : `${current}${unit}`;
  const totalText = total === null ? "—" : `${total}${unit}`;
  return `${currentText} / ${totalText}`;
}

export function sumUsageValues(values: Array<number | null>): number | null {
  const present = values.filter((value): value is number => value !== null && Number.isFinite(value));
  return present.length > 0 ? present.reduce((sum, value) => sum + value, 0) : null;
}

/** Title-cases a raw provider state for display: "STAGING" → "Staging". */
export function titleCase(input: string): string {
  if (!input) return "—";
  return input.charAt(0).toUpperCase() + input.slice(1).toLowerCase();
}
